<template>
  <v-tooltip
    :bottom="position === 'bottom'"
    :left="position === 'left'"
    :right="position === 'right'"
    :top="position === 'top'"
    max-width="500px"
    content-class="e-help-tooltip__content"
    lang="pt-BR"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        id="btn-help"
        v-bind="attrs"
        v-on="on"
        icon
        small
        color="secondary"
        class="e-help-tooltip__btn ml-2 mb-2"
        :aria-label="ariaLabel"
      >
        <v-icon size="24">mdi-help-circle-outline</v-icon>
      </v-btn>
    </template>

    <v-card class="e-help-tooltip__card pa-3" color="transparent" flat>
      <span class="e-help-tooltip__text" v-html="text"></span>
    </v-card>
  </v-tooltip>
</template>

<script>
export default {
  name: "EHelpTooltip",
  props: {
    text: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      default: "Mais informações",
    },
    position: {
      type: String,
      default: "right",
    },
  },
};
</script>

/* Estilos globais para o tooltip - sem scoped */
<style lang="scss">
.e-help-tooltip__content {
  // background: transparent !important;
  background-color: rgb(36, 35, 35) !important;
  border: none !important;
  box-shadow: none !important;

  .v-tooltip__content {
    // background: transparent !important;
    background-color: rgb(36, 35, 35) !important;
    border: none !important;
  }
}

/* Aumentar a fonte do texto do tooltip */
.e-help-tooltip__text {
  font-size: 16px !important;
  line-height: 1.4 !important;
  text-align: left !important;
  color: white !important;
  font-weight: bold !important;

  /* Propriedades para hifenação */
  hyphens: auto !important;
  -webkit-hyphens: auto !important;
  -moz-hyphens: auto !important;
  -ms-hyphens: auto !important;

  /* Controle de quebra de palavras */
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;

  /* Define o idioma para hifenação (importante!) */
  -webkit-hyphenate-limit-before: 3;
  -webkit-hyphenate-limit-after: 3;
}

.meu-componente-especial .e-help-tooltip__btn {
  margin-top: 8.5px !important;
}
</style>
